// @ts-strict-ignore
import Link from 'next/link';
import styled from 'styled-components';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Element, Section } from 'src/constants/footfall';
import i18n from 'src/utils/translate';
import { TagLink } from 'styles-js/buttons';
import { fadeEllipsis } from 'styles-js/mixins/fade';
type Props = {
  tags: {
    name: string;
  }[];
  username: string;
};
export default function MemberTags({
  tags,
  username
}: Props) {
  const filteredTags = tags.reduce((acc, current) => {
    // remove duplicates
    if (!acc.find(term => term.name === current.name)) acc.push(current);
    return acc;
  }, []);
  const handleTagClick = () => {
    trackFootfallEvent(Event.Clicked, {
      clickType: 'member-card',
      clickMetadata: {
        section: Section.CommunityMembers,
        element: Element.MemberTag
      }
    });
  };
  const as = `/user/${username}`;
  const href = `/user/profile?username=${username}`;
  return <List data-sentry-element="List" data-sentry-component="MemberTags" data-sentry-source-file="memberTags.tsx">
      {filteredTags.map(({
      name
    }) => <li key={name}>
          <Link legacyBehavior passHref as={as} href={href}>
            <TagLink onClick={handleTagClick}>
              {name}
            </TagLink>
          </Link>
        </li>)}
      <li>
        <Link legacyBehavior passHref as={as} href={href} data-sentry-element="Link" data-sentry-source-file="memberTags.tsx">
          <SeeMoreLink onClick={handleTagClick} data-sentry-element="SeeMoreLink" data-sentry-source-file="memberTags.tsx">
            {i18n.t('See more')}
          </SeeMoreLink>
        </Link>
      </li>
    </List>;
}
const List = styled.ul`
  position: relative;
  height: 60px;
  overflow: hidden;
  list-style: none;
  margin: 0;
  padding: 0;

  &::after {
    ${fadeEllipsis}
    height: 28px;
    right: 50px;
  }

  li {
    display: inline-block;
  }
`;
const SeeMoreLink = styled.a`
  position: absolute;
  bottom: 0;
  right: 0;
  padding-top: 3px;
  padding-left: 15px;
  z-index: 1;
  background-color: ${({
  theme
}) => theme.colorWhite};
  color: ${({
  theme
}) => theme.colorBlue};
  line-height: ${({
  theme
}) => theme.fontLineHeightM};
`;